import {Display} from "./Display";
import {Lightbox} from "./Lightbox";
import {Browser} from "./Browser";
import {History} from "./History";
import {Slider} from "./Slider";

// noinspection JSUnresolvedVariable,JSUnresolvedFunction
export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.lang = 'de';
        Basic.parallaxFactor = 15;
        Basic.resizeTimer = 0;
        Basic.scrollTimer = 0;
        Basic.ise = (document.body.dataset.ise === 'on');
        Basic.transitionTimer = 400;
        Basic.sliders = {};
        Basic.header = document.getElementById('header');
        Basic.menuButton = document.getElementById('menu-button');
        Basic.chronicles = document.body.querySelectorAll('.text-chronicle p');
        Basic.anchorMenu = document.getElementById('anchor-menu');
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click', e =>
        {
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                return false;
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
                el.dataset.f)
            {
                e.preventDefault();

                switch(el.dataset.f)
                {
                    case 'lightbox':
                        const imgElLb = el.querySelector('.slider-img');
                        if(imgElLb.getBoundingClientRect()['left'] > 0 &&
                            imgElLb.getBoundingClientRect()['left'] + imgElLb.getBoundingClientRect()['width'] < Display.x)
                        {
                            Slider.stop_autoscroll(el);
                            Basic.load({
                                f: 'lightbox',
                                action: el.dataset.action,
                                url: el.href
                            }).then(r =>
                            {
                                const currentPage = (document.documentURI && document.documentURI !== "undefined")
                                        ? document.documentURI
                                        : document.location.pathname,
                                    currentTitle = document.title;
                                History.push_url(el.href, r['pageTitle'], 0);
                                new Lightbox(r['html'], currentPage, currentTitle);
                            }).catch(error =>
                            {
                                document.documentElement.classList.remove('waiting');
                                console.error(error);
                            });
                        }
                        break;

                    case 'load-href':
                    case 'load-href-ext':
                    case 'load-video':
                        const imgEl = el.querySelector('.slider-img');
                        if(imgEl.getBoundingClientRect()['left'] > 0 &&
                           imgEl.getBoundingClientRect()['left'] + imgEl.getBoundingClientRect()['width'] < Display.x)
                        {
                            switch(el.dataset.f)
                            {
                                case 'load-href':
                                    document.location = el.href;
                                    break;

                                case 'load-href-ext':
                                    window.open(el.href,'_blank');
                                    break;

                                case 'load-video':
                                    Slider.stop_autoscroll(el);
                                    Basic.play_video(el);
                                    break;
                            }
                        }
                        break;

                    case 'load-news':
                        document.location = el.querySelector('.news-link').href;
                        break;

                    case 'toggle-menu':
                        const myHeader = document.getElementById('header'),
                            myMenuButton = document.getElementById('menu-button');
                        if(myHeader && myMenuButton)
                        {
                            myHeader.classList.toggle('slim');
                            if(myHeader.classList.contains('slim'))
                            {
                                myMenuButton.classList.remove('open');
                            }
                            else
                            {
                                myMenuButton.classList.add('open');
                            }
                        }
                        break;

                    case 'toggle-search':
                        const myForm = document.getElementById('form-search');
                        if(myForm)
                        {
                            if(myForm.classList.contains('none'))
                            {
                                myForm.classList.remove('none');
                                myForm.querySelector('.input-search').focus();
                            }
                            else
                            {
                                myForm.classList.add('none');
                            }
                        }
                        break;

                    case 'toggle-student-year':
                        const myTargetId = el.href.split('#')[1],
                            myYears = document.body.querySelectorAll('.student-year-names.active,.link-on-bg.only-on-hover.active');
                        myYears.forEach(el =>
                        {
                            el.classList.remove('active');
                        });
                        if(document.getElementById(myTargetId))
                        {
                            el.closest('.link-on-bg').classList.add('active');
                            document.getElementById(myTargetId).closest('.student-year-names').classList.add('active')
                        }
                        break;

                    case 'video':
                        Basic.build_videoIFrame(el);
                        break;

                    default:
                        console.log('Missing case: ' + el.dataset.f);
                }
            }
        });
    }

    static add_mouseMoveEvent()
    {
        document.body.addEventListener('mousemove', e =>
        {
            const parent = e.target.closest('.animated-back');

            if(parent)
            {
                const cursorX = Math.round((e.pageX - Display.x / 2) / 25),
                    cursorY = Math.round((e.pageY - parent.getBoundingClientRect()['top'] - window.scrollY) / 25);

                const myElements = parent.querySelectorAll('.animated-el:not(.reverse)');
                myElements.forEach(el =>
                {
                    el.style.transform = 'translate(' + cursorX.toString() + 'px,' + cursorY.toString() + 'px)';
                });

                const myElementsReversed = parent.querySelectorAll('.animated-el.reverse');
                myElementsReversed.forEach(el =>
                {
                    el.style.transform = 'translate(' + (cursorX * -1) + 'px,' + (cursorY * -1) + 'px)';
                });
            }
        }, true);
    }


    static build_videoIFrame(el)
    {
        const myIframe = document.createElement('iframe');
        myIframe.src = Basic.get_iFrameSrc(el);
        myIframe.classList.add('video-iframe');
        myIframe.frameborder = 0;
        myIframe.allowfullscreen = 1;
        myIframe.setAttribute('allow','autoplay; fullscreen');
        myIframe.style.width = '100%';
        myIframe.style.height = (el.getBoundingClientRect()['width'] * 9 / 16).toString() + 'px';
        el.innerHTML = '';
        el.classList.remove('video-click-to-play');
        el.appendChild(myIframe);
    }

    static get_iFrameSrc(el)
    {
        let url = el.href;
        switch(el.dataset.videoType)
        {
            case 'youtube':
                url = 'https://www.youtube-nocookie.com/embed/' +
                    el.dataset.videoCode +
                    '?showinfo=0' +
                    '&controls=1' +
                    '&fs=1' +
                    '&rel=0' +
                    '&hl=' + Basic.lang +
                    '&autoplay=1' +
                    '&modestbranding=1' +
                    '&showsearch=0';
                break;

            case 'vimeo':
                url = 'https://player.vimeo.com/video/' + el.dataset.videoCode +
                    '?autoplay=1' +
                    '&badge=0' +
                    '&byline=0' +
                    '&portrait=0' +
                    '&title=0' +
                    '&dnt=1';
                break;

            default:
                alert('Unknown video type');
        }
        return url;
    }

    static load(myData)
    {
        if(myData.url && !document.body.classList.contains('waiting'))
        {
            document.body.classList.add('waiting');
            myData.time = new Date().getTime();

            return new Promise(function(resolve, reject)
            {
                const myRequest = new XMLHttpRequest();
                myRequest.timeout = 10000;
                myRequest.onreadystatechange = function()
                {
                    if(myRequest.readyState === 4)
                    {
                        document.body.classList.remove('waiting');
                        if(myRequest.status === 200 && myRequest.response)
                        {
                            if(myRequest.response['status'] === true)
                            {
                                resolve(myRequest.response);
                            }
                            else
                            {
                                reject(myRequest.response);
                            }
                        }
                        else
                        {
                            reject('Empty response. Status: ' + myRequest.status);
                        }
                    }
                };

                myRequest.ontimeout = function()
                {
                    document.body.classList.remove('waiting');
                    reject('Request timed out. Network problems?');
                };

                myRequest.open("POST",Basic.base + 'index.php');
                myRequest.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
                myRequest.setRequestHeader("Accept","application/json");
                myRequest.responseType = 'json';
                myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
            });
        }
    }

    static play_video(el)
    {
        const parentEl = el.querySelector('.slider-video');

        if(!parentEl.classList.contains('playing'))
        {
            document.body.classList.add('waiting');
            const videosPlaying = document.body.querySelectorAll('.playing');
            for(let i = 0; i < videosPlaying.length; i++)
            {
                const myVideo = videosPlaying[i].querySelector('video');
                myVideo.pause();
                myVideo.style.opacity = '0';
                setTimeout(() =>
                {
                    videosPlaying[i].classList.remove('playing');
                    myVideo.remove();
                }, 350);
            }

            parentEl.classList.add('playing');
            const myVideo = document.createElement('video');
            myVideo.classList.add('portrait-video');
            myVideo.src = el.href;
            myVideo.style.opacity = '0';
            myVideo.controls = true;
            parentEl.appendChild(myVideo);

            myVideo.addEventListener('canplay', () =>
            {
                document.body.classList.remove('waiting');
                myVideo.style.opacity = '1';
                myVideo.play().then();
            });

            myVideo.addEventListener('ended', () =>
            {
                myVideo.style.opacity = '0';
                setTimeout(() =>
                {
                    parentEl.classList.remove('playing');
                    myVideo.remove();
                }, 350);
            });

            if(Browser.mobile === true)
            {
                myVideo.play().then();
            }
        }
    }

    static process_resize()
    {
        Display.analyze();
    }

    static process_scroll()
    {
        const scrollPosY = window.scrollY,
              autosliders = document.body.querySelectorAll('.autoscroll-slider');
        let elPos, elSizeY, mySliderId;

        //document.body.style.setProperty('--parallax-y', Math.round(scrollPosY / Basic.parallaxFactor) + 'px');

        if(Basic.header)
        {
            if(Display.device === 'smartphone')
            {
                Basic.header.classList.add('slim');
                Basic.menuButton.classList.remove('open');
            }
            else if(scrollPosY > 65 && !Basic.header.classList.contains('slim'))
            {
                Basic.header.classList.add('slim');
            }
            else if(scrollPosY <= 65 && Basic.header.classList.contains('slim'))
            {
                Basic.header.classList.remove('slim');
            }
        }

        Basic.chronicles.forEach(el =>
        {
            elPos = el.getBoundingClientRect()['top'] + scrollPosY;
            elSizeY = el.getBoundingClientRect()['height'];

            if(elPos >= scrollPosY &&
               elPos + elSizeY / 2 <= (Display.y + scrollPosY))
            {
                el.classList.remove('faded');
            }
            else
            {
                el.classList.add('faded');
            }
        });

        if(Browser.mobile === false &&
           Display.device !== 'smartphone' &&
           Basic.anchorMenu)
        {
            if(Math.floor(Basic.anchorMenu.getBoundingClientRect()['top'] + window.scrollY) > parseInt(Basic.anchorMenu.dataset.posY))
            {
                Basic.anchorMenu.classList.add('out');
            }
            else
            {
                Basic.anchorMenu.classList.remove('out');
            }
        }

        if(!document.body.classList.contains('body-yellow-bg'))
        {
            const myBgs = document.body.querySelectorAll('.yellow-bg-div');
            let skip = false;

            myBgs.forEach(el =>
            {
                elPos = el.getBoundingClientRect()['top'];
                elSizeY = el.getBoundingClientRect()['height'] + elPos;
                if(!skip && ((elPos > -200 && elPos < 200) || (elSizeY > -200 && elSizeY < 200)))
                {
                    if(!document.body.classList.contains('switch-menu-color') &&
                      (elPos < 56 && elPos > -200 || elSizeY > 55 && elSizeY < 200))
                    {
                        document.body.classList.add('switch-menu-color');
                        skip = true;
                    }
                    else if(document.body.classList.contains('switch-menu-color') &&
                           ((elPos > 55 && elPos < 200) || (elSizeY < 56 && elSizeY > -200)))
                    {
                        document.body.classList.remove('switch-menu-color');
                        skip = true;
                    }
                }
            });
        }

        autosliders.forEach(el =>
        {
            elPos = el.getBoundingClientRect()['top'] + scrollPosY;
            elSizeY = el.getBoundingClientRect()['height'];

            if(elPos + elSizeY >= scrollPosY &&
               elPos <= scrollPosY + Display.y)
            {
                if(!el.classList.contains('autoscrolling'))
                {
                   el.classList.add('autoscrolling');
                    mySliderId = parseInt(el.dataset.sliderNo);

                    if(Basic.sliders[mySliderId].autoscroll === false)
                    {
                        Basic.sliders[mySliderId].autoscroll = true;

                        if(Basic.sliders[mySliderId].timeout !== undefined)
                        {
                            clearTimeout(Basic.sliders[mySliderId].timeout);
                        }

                        Basic.sliders[mySliderId].timeout = setTimeout(() =>
                        {
                            Basic.sliders[mySliderId].autoscrollNow();
                        },3000);
                    }
                }
            }
            else
            {
                if(el.classList.contains('autoscrolling'))
                {
                    mySliderId = parseInt(el.dataset.sliderNo);
                    if(Basic.sliders[mySliderId].timeout !== undefined)
                    {
                        clearTimeout(Basic.sliders[mySliderId].timeout);
                    }
                    el.classList.remove('autoscrolling');
                    Basic.sliders[mySliderId].autoscroll = false;
                }
            }
        });
    }
}

